<template>
  <div>
    <modal-respaldos :listRespaldos="partido.respaldos"></modal-respaldos>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showUpdateMatch"
      scrollable
      no-close-on-backdrop
      title="Detalle Partido"
      cancel-variant="outline-secondary"
      @hidden="resetModal"
      size="lg"
    >
      <b-overlay :show="showLoadingModal" rounded="sm">
        <template>
          <b-row>
            <b-col md="6"> <b>Categoría: </b>{{ partido.categoria }} </b-col>
            <b-col md="2"> <b>E: </b> {{ partido.etapa }}</b-col>
            <b-col md="2"> <b>G: </b> {{ partido.grupo }} </b-col>
            <b-col md="2"> <b>#: </b> {{ partido.numero_fecha }} </b-col>
            <!-- <b-col md="12"> <b>Generados por: </b> Vocalia App </b-col> -->
            <b-col md="8" class="mt-1">
              <!-- <label for="example-datepicker"><b>Fecha: </b> </label> -->
              <b-form-datepicker
                id="example-datepicker"
                v-model="partido.fecha"
                size="sm"
                reset-button
                placeholder="Elegir Fecha"
                @input="updateHoraFechaEtc('f')"
                :disabled="
                  partido.final == 'PJ' &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
                    ? false
                    : true
                "
              />
            </b-col>
            <b-col md="4" class="mt-1">
              <!-- <b-form-timepicker
                size="sm"
                placeholder="Hora"
                v-model="partido.horario"
                reset-button
                @hidden="updateHoraFechaEtc('h')"
                :disabled="
                  partido.final == 'PJ' &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
                    ? false
                    : true
                "
              /> -->
              <b-form-group>
                <cleave
                  id="time"
                  v-model="partido.horario"
                  class="form-control"
                  style="height:35px"
                  @blur="updateHoraFechaEtc('h')"
                  :raw="false"
                  :options="time"
                  placeholder="hh:mm"
                  :disabled="
                    partido.final == 'PJ' &&
                    (USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TECNICA)
                      ? false
                      : true
                  "
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col md="6">
              <v-select
                id="input-posicion"
                placeholder="Cancha"
                dense
                outlined
                class="select-size-sm"
                v-model="partido.cancha"
                :options="canchas"
                @input="updateHoraFechaEtc('c')"
                :disabled="
                  partido.final == 'PJ' &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
                    ? false
                    : true
                "
              ></v-select>
            </b-col>
            <b-col md="6">
              <v-select
                id="input-posicion"
                placeholder="Vocal"
                class="select-size-sm"
                :options="vocales"
                v-model="partido.vocal"
                taggable
                @input="updateHoraFechaEtc('v')"
                :disabled="
                  partido.final == 'PJ' &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
                    ? false
                    : true
                "
              ></v-select>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col md="6">
              <v-select
                id="input-posicion"
                placeholder="Veedor"
                dense
                outlined
                class="select-size-sm"
                :options="veedores"
                v-model="partido.veedor"
                taggable
                @input="updateHoraFechaEtc('ve')"
                :disabled="
                  partido.final == 'PJ' &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
                    ? false
                    : true
                "
              ></v-select>
            </b-col>
            <b-col md="6">
              <v-select
                id="input-posicion"
                placeholder="Administrador"
                dense
                class="select-size-sm"
                outlined
                :options="admins"
                v-model="partido.usuario_editar"
                @input="updateHoraFechaEtc('ua')"
                :disabled="
                  partido.final == 'PJ' &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
                    ? false
                    : true
                "
              ></v-select>
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col md="6">
              <v-select
                id="input-arbitro"
                placeholder="Arbitro"
                dense
                outlined
                class="select-size-sm"
                :options="arbitros"
                v-model="partido.arbitro"
                taggable
                @input="updateHoraFechaEtc('arb')"
                :disabled="
                  partido.final == 'PJ' &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
                    ? false
                    : true
                "
              ></v-select>
            </b-col>
            <b-col md="3">
              <v-select
                id="input-camerino-local"
                placeholder="Cam.L"
                dense
                outlined
                class="select-size-sm"
                :options="[]"
                v-model="partido.cam_local"
                taggable
                @input="updateHoraFechaEtc('cam_local')"
                :disabled="
                  partido.final == 'PJ' &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
                    ? false
                    : true
                "
              ></v-select>
            </b-col>
            <b-col md="3">
              <v-select
                id="input-camerino-visita"
                placeholder="Cam.V"
                dense
                outlined
                class="select-size-sm"
                :options="[]"
                v-model="partido.cam_visita"
                taggable
                @input="updateHoraFechaEtc('cam_visita')"
                :disabled="
                  partido.final == 'PJ' &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
                    ? false
                    : true
                "
              ></v-select>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="12" class="text-center">
              <b-alert
                v-if="partido.final != 'PJ' && partido.final != 'NPN'"
                :show="true"
                v-height-fade.appear
                variant="success"
              >
                <div class="alert-body">
                  FINALIZADO
                </div>
                <span @click="openVocalia" class="ver-vocalia"
                  >Ver Vocalia</span
                >
              </b-alert>
              <b-alert
                v-else-if="partido.final != 'PJ' && partido.final == 'NPN'"
                :show="true"
                v-height-fade.appear
                variant="success"
              >
                <div class="alert-body">
                  FINALIZADO (Ninguno se presenta)
                </div>
                <span @click="openVocalia" class="ver-vocalia"
                  >Ver Vocalia</span
                >
              </b-alert>
              <b-alert
                v-else
                :show="true"
                v-height-fade.appear
                variant="danger"
              >
                <div class="alert-body">
                  POR JUGAR
                </div>
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" class="text-center">
              <div class="text-white name-equipo text-truncate">
                {{ partido.nom_local }}
              </div>
              <img :src="partido.foto_local" alt="N.D" width="100" />
              <br />
              <div style="display:flex; justify-content:center;margin-top:5px">
                <b-form-input
                  id="input-goles-local"
                  type="number"
                  placeholder="Goles"
                  size="sm"
                  v-model="totalLocal"
                  style=" width:29%; font-size:17px;"
                  class="pl-2"
                  disabled
                />
                <span
                  v-if="partido.penales == 's'"
                  style="padding:5px;color:darkgray"
                  >({{ partido.penal_local }})</span
                >
              </div>
              <div
                style="margin-top:10px;display: flex;justify-content: center"
              >
                <b-form-radio
                  v-model="partido.radioNoPresentacion"
                  @change="changeNoPresentacion(goles_no_presentacion, 0)"
                  style="text-align:left !important"
                  name="no-presentation"
                  value="ganaLocal"
                  :disabled="
                    partido.final == 'PJ' &&
                    (USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TECNICA)
                      ? false
                      : true
                  "
                >
                  <span style="font-size:11px; color:#670d08"
                    >gana por no presentación
                  </span>
                </b-form-radio>
              </div>
              <!-- <b-form-spinbutton v-model="totalLocal" id="sb-inline" inline /> -->
            </b-col>
            <b-col md="6" class="text-center">
              <div class="text-white name-equipo text-truncate">
                {{ partido.nom_visita }}
              </div>
              <img :src="partido.foto_visita" alt="N.D" width="100" />
              <br />
              <div style="display:flex; justify-content:center; margin-top:5px">
                <b-form-input
                  id="input-goles-visita"
                  type="number"
                  placeholder="Goles"
                  size="sm"
                  v-model="totalVisita"
                  style=" width:29%; font-size:17px;"
                  class="pl-2"
                  disabled
                />
                <span
                  v-if="partido.penales == 's'"
                  style="padding:5px;color:darkgray"
                  >({{ partido.penal_visita }})</span
                >
              </div>
              <div
                style="margin-top:10px;display: flex;justify-content: center"
              >
                <b-form-radio
                  @change="changeNoPresentacion(0, goles_no_presentacion)"
                  v-model="partido.radioNoPresentacion"
                  value="ganaVisita"
                  style="text-align:left !important"
                  name="no-presentation"
                  :disabled="
                    partido.final == 'PJ' &&
                    (USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TECNICA)
                      ? false
                      : true
                  "
                >
                  <span style="font-size:11px; color:#670d08"
                    >gana por no presentación
                  </span>
                </b-form-radio>
              </div>
              <!-- <b-form-spinbutton v-model="totalVisita" id="sb-inline" inline /> -->
            </b-col>
          </b-row>
          <b-row
            v-if="partido.motivo != null && partido.motivo != ''"
            class="ml-1 mr-1"
          >
            <b-col
              md="12"
              class="mt-2"
              style="background-color: #a40202;color: white; padding: 10px; border-radius: 5px"
            >
              Sancion: <b>{{ partido.motivo }} </b><br />
              {{ partido.detalle }} <br />

              <span
                v-if="
                  partido.reset_opcion === '3' || partido.reset_opcion === '5'
                "
                >gana club {{ partido.nom_local }}</span
              >
              <span
                v-else-if="
                  partido.reset_opcion === '4' || partido.reset_opcion === '6'
                "
              >
                gana club {{ partido.nom_visita }}</span
              >
            </b-col>
          </b-row>
          <b-row
            v-if="categoriaSeleccionada.id_disciplina !== DISCIPLINAS.ECUAVOLEY"
          >
            <b-col md="6" class="mt-1">
              <b-row
                class="d-flex align-items-center"
                style="font-size:12px; margin-left:0px; margin-right:0px; background-color:#e6e4e4;margin-bottom:5px"
              >
                <b-col md="2" class="p-0 ml-1"> #</b-col>
                <b-col md="3" class="p-0 ml-1"> Goles</b-col>
                <b-col md="2" class="p-0 "> </b-col>
                <b-col
                  md="3"
                  class="p-0"
                  style="display:flex; justify-content:flex-end"
                >
                  <b-button
                    v-if="partido.final == 'PJ'"
                    @click="drawTable(listLocal)"
                    variant="flat-success"
                    class="btn-icon"
                    size="sm"
                  >
                    <feather-icon icon="PlusIcon" /> </b-button
                ></b-col>
              </b-row>
              <item-gol-tarjeta
                v-for="item in listLocal"
                :key="item.id"
                :item="item"
                :estadoPartido="partido.final"
                :partido="partido"
                @sumaGoles="sumarGoles(listLocal)"
                @deleteItem="deleteItem($event, listLocal)"
                @verifyPlayer="
                  verifyPlayer($event, listPlayersLocal, listLocal)
                "
              ></item-gol-tarjeta>
            </b-col>
            <b-col md="6" class="mt-1">
              <b-row
                class="d-flex align-items-center"
                style="font-size:12px; margin-left:0px; margin-right:0px; background-color:#e6e4e4;margin-bottom:5px"
              >
                <b-col md="2" class="p-0 ml-1"> #</b-col>
                <b-col md="3" class="p-0 ml-1"> Goles</b-col>
                <b-col md="2" class="p-0 "> </b-col>
                <b-col
                  md="3"
                  class="p-0"
                  style="display:flex; justify-content:flex-end"
                >
                  <b-button
                    v-if="partido.final == 'PJ'"
                    @click="drawTable(listVisita)"
                    variant="flat-success"
                    class="btn-icon"
                    size="sm"
                  >
                    <feather-icon icon="PlusIcon" /> </b-button
                ></b-col>
              </b-row>
              <item-gol-tarjeta
                v-for="item in listVisita"
                :key="item.id"
                :item="item"
                :estadoPartido="partido.final"
                :partido="partido"
                @sumaGoles="sumarGoles(listVisita)"
                @deleteItem="deleteItem($event, listVisita)"
                @verifyPlayer="
                  verifyPlayer($event, listPlayersVisita, listVisita)
                "
              ></item-gol-tarjeta>
            </b-col>
          </b-row>
          <template
            v-if="categoriaSeleccionada.id_disciplina === DISCIPLINAS.ECUAVOLEY"
          >
            <item-set
              v-for="item in listSets"
              :key="item.id"
              :item="item"
              @sumaSets="sumarSets(listSets, $event)"
              :estadoPartido="partido.final"
            ></item-set>
          </template>
        </template>
        <span
          v-if="partido.final != 'PJ'"
          style="color: gray; font-weight: bold;font-size: 12px;"
          >Actualizado {{ partido.fecha_subida }} mediante
          {{ partido.act_por }} por {{ partido.user_modifica }}</span
        >
        <div
          v-if="partido.final != 'PJ'"
          :style="
            partido.voc_revisada === null || partido.voc_revisada === 'n'
              ? 'background:#fff7b8;width:60%;padding:5px;font-size:12px;border-radius:5px'
              : 'background:#b7ffb7;width:60%;padding:5px;font-size:12px;border-radius:5px'
          "
        >
          Vocalia revisada o aprobada:
          {{ partido.voc_revisada === 's' ? 'SI' : 'NO' }}
          <span v-if="partido.voc_revisada === 's'"
            >por ({{ partido.user_revisa }} / {{ partido.fecha_revisa }}) usa
            opcion
            {{
              partido.revisado_opc === '1'
                ? 'Genera valores por tarjetas'
                : 'NO se genero valores por tarjetas'
            }}</span
          >
        </div>
        <div
          v-if="partido.respaldos.length != 0"
          @click="openRespaldos"
          style="text-decoration:underline;font-size:10px;color:gray;cursor:pointer;float:right"
        >
          <span>Respaldos vocalias </span>
        </div>
        <div v-if="partido.final!='PJ'" style="font-size:10px;color:red">
          Recuerda unicamente se puede dar de baja a partidos que no tienen
          sanciones aplicadas a jugadores o al partido
        </div>
      </b-overlay>
      <template #modal-footer>
        <div class="w-100">
          <template v-if="!showLoading">
            <a
              v-if="
                partido.final == 'PJ' &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
              "
              @click="noSePresentaNinguno"
              href="#"
              style="font-size:12px;position: absolute;bottom: 15px; text-decoration: underline;"
              >No se presenta ningun equipo</a
            >
            <b-button
              v-if="
                (partido.reset_opcion === null ||
                  partido.reset_opcion === '0') &&
                  partido.permitirBaja &&
                  (USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA)
              "
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="float-right"
              @click="showConfirmacion = true"
            >
              <span v-if="partido.final == 'PJ'">Guardar</span>
              <span v-else>Dar de baja</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="float-right mr-1"
              @click="resetModal"
            >
              Cancelar
            </b-button>
          </template>
          <!-- <div v-if="showLoading" class="text-center mt-1">
            <b-spinner variant="primary" label="Text Centered" />
          </div> -->
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="modal-multi-3"
      size="sm"
      title="Confirmación"
      ok-only
      ok-title="Accept"
      v-model="showConfirmacion"
      @hidden="closeConfirmacion"
    >
      <b-card-text v-if="partido.final == 'PJ' && noSePresentan" class="my-1">
        Ningún equipo se presenta.
        <br />
        Asegúrate que la información proporcionada sea la correcta.
        <br />
        ¿ Deseas guardar los cambios ?
      </b-card-text>
      <b-card-text
        v-else-if="partido.final == 'PJ' && !noSePresentan"
        class="my-1"
      >
        Asegúrate que la información proporcionada sea la correcta.
        <br />
        ¿ Deseas guardar los cambios ?
      </b-card-text>
      <template v-else-if="partido.final != 'PJ'">
        <b-card-text>
          <b>¿ Qué deseas realizar ?</b>
        </b-card-text>
        <span style="font-size:11px; color:black;"> Resetear el partido </span>
        <b-form-radio
          v-model="accionBaja"
          style="text-align:left !important;margin-top:10px;margin-bottom:10px"
          name="accion-baja"
          value="1"
        >
          <span style="font-size:12px; color:#670d08"
            >El partido sera marcado como no jugado, no se conservan goles,
            tarjetas ni actuaciones y el puntaje regresa a la instancia antes de
            jugarse(recomendado para subirse nuevamente desde vocalia app).
          </span>
        </b-form-radio>
        <b-form-radio
          v-model="accionBaja"
          style="text-align:left !important;margin-top:10px;margin-bottom:10px"
          name="accion-baja"
          value="2"
        >
          <span style="font-size:12px; color:#670d08"
            >El partido sera marcado como no jugado, no se conservan goles,
            tarjetas, SE CONSERVARAN las ACTUACIONES y el puntaje regresa a la
            instancia antes de jugarse(recomendado para subirse nuevamente desde
            web app).
          </span>
        </b-form-radio>
      </template>
      <template #modal-footer>
        <template v-if="!showLoading">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="showConfirmacion = false"
          >
            Cancelar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="actionAceptar"
          >
            Aceptar
          </b-button>
        </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable */
import {
  //   BCard,
  //   BCardText,
  BRow,
  BCol,
  //   BListGroupItem,
  //   BAvatar,
  BButton,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BFormTimepicker,
  BAlert,
  BCardText,
  BOverlay,
  BSpinner,
  BFormTextarea,
  //   BFormSpinbutton,
  //   BFormRadio,
  //   BTable,
  //   BMedia,
  //   BAvatar,
  VBTooltip,
  BFormRadio,
  //   BBadge,
  //   BButtonGroup,
} from 'bootstrap-vue'
import { ref, computed, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'
import { heightFade } from '@core/directives/animations'
import store from '@/store'
import Vue from 'vue'

// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ItemGolTarjeta from './ItemGolTarjeta.vue'
import ItemSet from './ItemSet.vue'
import ModalRespaldos from './ModalRespaldos.vue'
import apiCall from '../../utils/apiCall'
import {
  URL,
  TARJETAS,
  USER,
  ROLES,
  URL_PDF,
  DISCIPLINAS,
  // xxx,
} from '../../utils/variables'
// import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    BFormTimepicker,
    vSelect,
    BFormRadio,
    ModalRespaldos,
    // BFormSpinbutton,
    // BFormRadio,
    BButton,
    ItemGolTarjeta,
    ItemSet,
    BAlert,
    BCardText,
    BOverlay,
    BSpinner,
    BFormTextarea,
    Cleave,
    // eslint-disable-next-line vue/no-unused-components
    // ToastificationContent,
    // BFormCheckbox,
    // VBTooltip,
    // flatPickr,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    heightFade,
  },
  props: {
    partido: Object,
    categoriaSeleccionada: Object,
    canchas: Array,
    vocales: Array,
    veedores: Array,
    arbitros: Array,
    admins: Array,
    listPlayersLocal: Array,
    listPlayersVisita: Array,
    listLocal: Array,
    listVisita: Array,
    listSets: Array,
    goles_no_presentacion: String,
    quitar_goles_no_se_presentan: String,
    showLoadingModal: Boolean,
  },
  setup(props, { emit }) {
    const value = ref(null)
    const timePicker = ref('')
    const nameVocal = ref('')
    const nameVeedor = ref('')
    const cancha = ref('')
    const showLoading = ref(false)
    const messageError = ref('')
    const variante = ref('danger')
    const dismissCountDown = ref(0)
    const hasError = ref(false)
    const showConfirmacion = ref(false)
    const continuar = ref(false)
    const noSePresentan = ref(false)
    const radioUsar = ref('')
    const accionBaja = ref('')
    const time = ref({
      time: true,
      timePattern: ['h', 'm'],
    })
    // const glnp = ref(false)
    // const gvnp = ref(false)
    const dismissSecs = ref(3)
    const dataReset = {
      goles_local: null,
      goles_visita: null,
      glnp: false,
      gvnp: false,
      final: 'PJ',
      penales: null,
      reset: null,
    }
    // const totalLocal = ref(0)
    // const totalVisita = ref(0)
    // const listLocal = ref([])
    // const listVisita = ref([])
    const { postApi } = apiCall()
    function openVocalia() {
      window.open(
        `${URL_PDF}pdfVocalia/vocalia${
          props.partido.id_partido
        }.pdf?v=${Math.random() * 100}`,
        '_blank'
      )
    }
    function actualizarSet(valor, index) {
      console.log(valor)
      console.log(index)
      // props.partido.sets[index] = valor
      // props.partido.sets.splice(index,1)
      // Vue.set(props.partido.sets, index, valor);
      // this.$forceUpdate()
      // let total = sumarSets(props.partido.sets, 'local')
      // console.log(total)
      // console.log(props.partido.sets)
    }
    function openRespaldos() {
      store.commit('someVariables/UPDATE_SHOW_RESPALDOS', true)
    }
    function changeNoPresentacion(valorLocal, valorVisita) {
      document.getElementById('input-goles-visita').value = valorVisita
      document.getElementById('input-goles-local').value = valorLocal
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function noSePresentaNinguno() {
      showConfirmacion.value = true
      noSePresentan.value = true
    }
    function closeConfirmacion() {
      showConfirmacion.value = false
      noSePresentan.value = false
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function drawTable(arrayList) {
      const size = arrayList.length
      const item = {
        numeroCamiseta: null,
        goles: null,
        tarjeta: null,
        position: size,
        color: 'red',
        disabled: true,
      }
      arrayList.push(item)
    }
    function sumarGoles(arrayList, tipo, glnp, gvnp) {
      // console.log(arrayList, tipo, glnp, glnp)
      // console.log(props.partido.reset)

      let total = 0
      if (tipo === 'local') {
        if (glnp) {
          total = props.goles_no_presentacion
        } else {
          if (props.partido.reset === 'PJ' || props.partido.reset === null) {
            if (arrayList != undefined) {
              if (arrayList.length > 0) {
                arrayList.forEach(element => {
                  total += Number(element.goles)
                })
              }
            }
          } else if (props.partido.reset === 'GL') {
            if (props.partido.mostrar_goles_por_sancion === 's') {
              total = props.goles_no_presentacion
            } else {
              if (arrayList != undefined) {
                if (arrayList.length > 0) {
                  arrayList.forEach(element => {
                    total += Number(element.goles)
                  })
                }
              }
            }
          } else if (props.partido.reset === 'GV') {
            if (props.partido.mostrar_goles_por_sancion === 's') {
              total = 0
            } else {
              if (arrayList != undefined) {
                if (arrayList.length > 0) {
                  arrayList.forEach(element => {
                    total += Number(element.goles)
                  })
                }
              }
            }
          } else if (props.partido.reset === 'E') {
            if (props.partido.mostrar_goles_por_sancion === 's') {
              total = 0
            } else {
              if (arrayList != undefined) {
                if (arrayList.length > 0) {
                  arrayList.forEach(element => {
                    total += Number(element.goles)
                  })
                }
              }
            }
          }
        }
      }
      if (tipo === 'visita') {
        if (gvnp) {
          total = props.goles_no_presentacion
        } else {
          if (props.partido.reset === 'PJ' || props.partido.reset === null) {
            if (arrayList != undefined) {
              if (arrayList.length > 0) {
                arrayList.forEach(element => {
                  total += Number(element.goles)
                })
              }
            }
          } else if (props.partido.reset === 'GL') {
            if (props.partido.mostrar_goles_por_sancion === 's') {
              total = 0
            } else {
              if (arrayList != undefined) {
                if (arrayList.length > 0) {
                  arrayList.forEach(element => {
                    total += Number(element.goles)
                  })
                }
              }
            }
          } else if (props.partido.reset === 'GV') {
            if (props.partido.mostrar_goles_por_sancion === 's') {
              total = props.goles_no_presentacion
            } else {
              if (arrayList != undefined) {
                if (arrayList.length > 0) {
                  arrayList.forEach(element => {
                    total += Number(element.goles)
                  })
                }
              }
            }
          } else if (props.partido.reset === 'E') {
            if (props.partido.mostrar_goles_por_sancion === 's') {
              total = 0
            } else {
              if (arrayList != undefined) {
                if (arrayList.length > 0) {
                  arrayList.forEach(element => {
                    total += Number(element.goles)
                  })
                }
              }
            }
          }
        }
      }

      return total
    }

    function sumarSets(arrayList, tipo, glnp, gvnp) {
      // console.log(arrayList)
      // console.log(tipo)
      let total = 0
      if (tipo === 'local') {
        if (glnp) {
          total = props.goles_no_presentacion
        } else {
          if (props.partido.reset === 'PJ' || props.partido.reset === null) {
            if (arrayList != undefined) {
              if (arrayList.length > 0) {
                arrayList.forEach(element => {
                  if (
                    parseInt(element.marcador_local) >
                    parseInt(element.marcador_visitante)
                  ) {
                    total += 1
                    // console.log('totalll: ' + total)
                  }
                })
              }
            }
          } else if (props.partido.reset === 'GL') {
            total = props.goles_no_presentacion
          } else if (props.partido.reset === 'GV') {
            total = 0
          }
        }
      }
      if (tipo === 'visita') {
        if (gvnp) {
          total = props.goles_no_presentacion
        } else {
          if (props.partido.reset === 'PJ' || props.partido.reset === null) {
            if (arrayList != undefined) {
              if (arrayList.length > 0) {
                arrayList.forEach(element => {
                  if (
                    parseInt(element.marcador_local) <
                    parseInt(element.marcador_visitante)
                  ) {
                    total += 1
                    // console.log('totalll: ' + total)
                  }
                })
              }
            }
          } else if (props.partido.reset === 'GL') {
            total = 0
          } else if (props.partido.reset === 'GV') {
            total = props.goles_no_presentacion
          }
        }
      }

      return total
    }
    function deleteItem(item, arrayList) {
      // console.log(item)
      arrayList.splice(item.position, 1)
      arrayList.forEach((element, index) => {
        element.position = index
      })
    }
    function isRepet(item, arrayList) {
      // console.log(arrayList)
      const resultado = arrayList.filter(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          element.numeroCamiseta === item.numeroCamiseta
        // element.numeroCamiseta === item.numeroCamiseta && !element.disabled
        // eslint-disable-next-line
      )
      // console.log(resultado)
      // eslint-disable-next-line
      const existe = resultado.length >= 2 ? true : false
      return existe
    }
    function existeYNoSancionado(item, arrayList) {
      const resultado = arrayList.find(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          element.num_camiseta === item.numeroCamiseta &&
          !element.sancionado &&
          // eslint-disable-next-line
          element.isCalificado
      )
      // console.log(resultado)
      // eslint-disable-next-line
      const isInArray = resultado
        ? { existe: true, idJugador: resultado.id_jugador }
        : { existe: false, idJugador: null }
      return isInArray
    }

    function verifyPlayer(item, arrayList, listItems) {
      const existeYValido = existeYNoSancionado(item, arrayList)
      // console.log(existeYValido, item)
      if (!isRepet(item, listItems)) {
        if (existeYValido.existe) {
          item.color = 'black'
          item.disabled = false
          item.idJugador = existeYValido.idJugador
        } else {
          item.color = 'red'
          item.disabled = true
          item.goles = ''
          item.idJugador = null
        }
      } else {
        item.color = 'red'
        item.disabled = true
        item.goles = ''
        item.idJugador = null
      }
    }

    function dataUpdatePartido(tipoCampo) {
      // console.log(props.partido)
      const data = {
        idPartido: props.partido.id_partido,
        tipo: tipoCampo,
        rol: USER().rol,
        cancha: null,
        vocal: null,
        veedor: null,
        id_user_admin: null,
        id_arbitro: null,
        cam_local: null,
        cam_visita: null,
      }
      // console.log(props.partido)
      if (tipoCampo === 'f') {
        data.fecha = props.partido.fecha
      } else if (tipoCampo === 'h') {
        data.horario = props.partido.horario.substring(0, 5)
      } else if (tipoCampo === 'v') {
        if (props.partido.vocal !== null) {
          data.vocal = props.partido.vocal.label
        }
      } else if (tipoCampo === 've') {
        if (props.partido.veedor !== null) {
          data.veedor = props.partido.veedor.label
        }
      } else if (tipoCampo === 'c') {
        if (props.partido.cancha !== null) {
          data.cancha = props.partido.cancha.value
        }
      } else if (tipoCampo === 'ua') {
        if (props.partido.usuario_editar !== null) {
          data.id_user_admin = props.partido.usuario_editar.value
        }
      } else if (tipoCampo === 'arb') {
        if (props.partido.arbitro !== null) {
          data.id_arbitro = props.partido.arbitro.value
        }
      } else if (tipoCampo === 'cam_local') {
        if (props.partido.cam_local !== null) {
          data.cam_local = props.partido.cam_local
        }
      } else if (tipoCampo === 'cam_visita') {
        if (props.partido.cam_visita !== null) {
          data.cam_visita = props.partido.cam_visita
        }
      }
      return data
    }
    function errorInUpdateExtras(tipoCampo) {
      if (tipoCampo === 'f') {
        props.partido.fecha = ''
      } else if (tipoCampo === 'h') {
        props.partido.horario = ''
      } else if (tipoCampo === 'v') {
        props.partido.vocal = null
      } else if (tipoCampo === 've') {
        props.partido.veedor = null
      } else if (tipoCampo === 'c') {
        props.partido.cancha = null
      } else if (tipoCampo === 'ua') {
        props.partido.id_user_admin = null
      }
    }
    async function updateHoraFechaEtc(tipoCampo) {
      // console.log(props.partido)
      if (props.partido.horario !== null) {
        props.partido.horario = props.partido.horario.substring(0, 5)
      }
      const path = 'ApiFixture/updateDatosPartido'
      const data = dataUpdatePartido(tipoCampo)
      // console.log(data)
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        console.log('si')
      } else {
        errorInUpdateExtras(tipoCampo)
        showMessageAlert('danger', response.mensaje)
      }
      //   cardItem.value.showLoading = false
    }
    function changeVocal(item) {
      // console.log(item)
      if (item !== '') {
        nameVocal.value = item
      }
    }
    function findVocal(item) {
      console.log(item)
      //   nameVocal.value = 'juan'
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      store.commit('someVariables/UPDATE_SHOW_UPDATE_MATCH', false)
      // emit('recargar', props.playerSelected.id_equipo)
      // console.log('hidden')
      // props.listLocal = []
      // props.listVisita = []
      // initPlayer()
      //       this.$emit('closeModal', false)
    }
    function transformarTarjeta(arrayList) {
      // console.log(arrayList)
      const listValidos = []
      if (arrayList != undefined) {
        if (arrayList.length !== 0) {
          arrayList.forEach(element => {
            if (!element.disabled) {
              element.tAmarilla = 0
              element.tRoja = 0
              element.rojDobA = 0
              if (element.tarjeta === TARJETAS.AMARILLA) {
                element.tAmarilla = 1
              } else if (element.tarjeta === TARJETAS.ROJA) {
                element.tRoja = 1
              } else if (element.tarjeta === TARJETAS.DOBLE_TA) {
                element.rojDobA = 1
              }
              listValidos.push(element)
            }
          })
        }
      }
      return listValidos
    }
    const radioNoPresentacion = computed({
      get: () => {
        let retorna = null
        if (props.partido.glnp) {
          retorna = 'ganaLocal'
        } else if (props.partido.gvnp) {
          retorna = 'ganaVisita'
        }
        // console.log(retorna)
        return retorna
      },
      set: value => {
        radioUsar.value = value
        // console.log(value)
      },
    })

    let glnp = computed({
      get: () => props.partido.glnp,
      set: value => {
        props.partido.glnp = value
      },
    })
    const gvnp = computed(() => props.partido.gvnp)

    const totalLocal = computed(() => {
      // console.log(props.categoriaSeleccionada)
      if (
        props.categoriaSeleccionada.id_disciplina == DISCIPLINAS.FUTBOL ||
        props.categoriaSeleccionada.id_disciplina == DISCIPLINAS.BALONCESTO
      ) {
        return sumarGoles(
          props.listLocal,
          'local',
          props.partido.glnp,
          props.partido.gvnp
        )
      } else if (
        props.categoriaSeleccionada.id_disciplina === DISCIPLINAS.ECUAVOLEY
      ) {
        return sumarSets(
          props.listSets,
          'local',
          props.partido.glnp,
          props.partido.gvnp
        )
      }
    })
    const totalVisita = computed(() => {
      if (
        props.categoriaSeleccionada.id_disciplina == DISCIPLINAS.FUTBOL ||
        props.categoriaSeleccionada.id_disciplina == DISCIPLINAS.BALONCESTO
      ) {
        return sumarGoles(
          props.listVisita,
          'visita',
          props.partido.glnp,
          props.partido.gvnp
        )
      } else if (
        props.categoriaSeleccionada.id_disciplina === DISCIPLINAS.ECUAVOLEY
      ) {
        return sumarSets(
          props.listSets,
          'visita',
          props.partido.glnp,
          props.partido.gvnp
        )
      }
    })
    function definirFinalPartido(data) {
      let finalString = ''
      // console.log(data)
      if (data.noSePresentan) {
        finalString = 'NPN'
      } else {
        if (data.glnp === true && data.gvnp === false) {
          finalString = 'GLNP'
        } else if (data.gvnp === true && data.glnp === false) {
          finalString = 'GVNP'
        } else if (data.glnp === false && data.gvnp === false) {
          if (data.goles_local > data.goles_visita) {
            finalString = 'GL'
          }
          if (data.goles_local < data.goles_visita) {
            finalString = 'GV'
          }
          if (data.goles_local === data.goles_visita) {
            finalString = 'E'
          }
        }
      }
      return finalString
    }
    function setPropsPartido(data) {
      props.partido.goles_local = data.goles_local
      props.partido.goles_visita = data.goles_visita
      props.partido.glnp = data.glnp
      props.partido.gvnp = data.gvnp
      noSePresentan.value = false
    }
    function transformRadioNoPresentacion() {
      let data = {
        glnp: false,
        gvnp: false,
      }
      if (props.partido.radioNoPresentacion === 'ganaLocal') {
        data.glnp = true
        data.gvnp = false
      } else if (props.partido.radioNoPresentacion === 'ganaVisita') {
        data.glnp = false
        data.gvnp = true
      } else {
        data.glnp = false
        data.gvnp = false
      }
      return data
    }
    function getSets() {
      let listSetsReturn = []
      if (props.categoriaSeleccionada.id_disciplina === DISCIPLINAS.ECUAVOLEY) {
        listSetsReturn = props.listSets
      }
      return listSetsReturn
    }
    async function savePartido() {
      // console.log(props.partido)
      showLoading.value = true
      continuar.value = true
      const listLocal = transformarTarjeta(props.listLocal)
      const listVisita = transformarTarjeta(props.listVisita)
      const dataNoPresentacion = transformRadioNoPresentacion()

      const data = {
        id_partido: props.partido.id_partido,
        id_local: props.partido.idLocal,
        id_categoria: props.partido.id_categoria,
        id_visita: props.partido.idVisita,
        goles_local: document.getElementById('input-goles-local').value,
        goles_visita: document.getElementById('input-goles-visita').value,
        actualizado_por: 'wApp',
        name_important: props.partido.name_important,
        id_disciplina: props.partido.id_disciplina,
        glnp: dataNoPresentacion.glnp,
        gvnp: dataNoPresentacion.gvnp,
        noSePresentan: noSePresentan.value,
        quitarGolesNoSePresentan: props.quitar_goles_no_se_presentan,
        golesNoPresentacion: props.goles_no_presentacion,
        equipo_local: listLocal,
        equipo_visita: listVisita,
        sets: getSets(),
        local: props.partido.nom_local,
        visita: props.partido.nom_visita,
        fecha: props.partido.fecha,
        idCancha: props.partido.id_cancha,
        rol: USER().rol,
        id_user_modifica: USER().id_usuario,
      }
      // console.log(data)
      const path = 'ApiFixture/actualizarPartidoWeb'
      const response = await postApi(URL, path, data)
      // console.log(response)
      if (response.flag === 'si') {
        props.partido.final = definirFinalPartido(data)
        setPropsPartido(data)

        // props.partido.goles_local = data.goles_local
        // props.partido.goles_visita = data.goles_visita
        // props.partido.glnp = false
        // props.partido.gvnp = false
        // props.partido.final = 'GL'
        // this.$bvToast.toast('Toast body content', {
        //   title: `saludos`,
        //   variant: 'success',
        //   solid: true,
        // })
        emit('recargar', props.partido)
        store.commit('someVariables/UPDATE_SHOW_UPDATE_MATCH', false)
      } else {
        props.partido.final = 'PJ'
        showMessageAlert('danger', 'Ha ocurrido un error vuelve a intentarlo')
        setPropsPartido(dataReset)
      }
      showConfirmacion.value = false
      showLoading.value = false
    }
    async function resetPartido() {
      // console.log(accionBaja.value)
      if (
        accionBaja.value === '' ||
        accionBaja.value === undefined ||
        accionBaja.value === null
      ) {
        showMessageAlert('danger', 'Debes seleccionar una opción')
      } else {
        showLoading.value = true
        continuar.value = true
        // console.log(props.partido)
        const data = {
          id_partido: props.partido.id_partido,
          name_important: props.partido.name_important,
          rol: USER().rol,
          quitarGolesNoSePresentan: props.quitar_goles_no_se_presentan,
          golesNoPresentacion: props.goles_no_presentacion,
          accion: accionBaja.value,
          tipoDato: 'tecnica',
          dataMovimiento: `Da de baja partido etapa:${props.partido.etapa} grupo:${props.partido.grupo} fecha #:${props.partido.numero_fecha} partido: ${props.partido.nom_local} vs ${props.partido.nom_visita} subido por el usuario
          ${props.partido.user_modifica}`,
          idTorneo:
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
          id_user_modifica: USER().id_usuario,
        }
        const path = 'ApiFixture/darBajaPartido'
        const response = await postApi(URL, path, data)
        // console.log(response)
        if (response.flag === 'si') {
          // props.partido.final = 'GL'
          if (accionBaja.value === '1') {
            props.partido.final = 'PJ'
            props.partido.reset = 'PJ'
          } else if (accionBaja.value === '2') {
            props.partido.final = 'PJ'
            props.partido.reset = 'PJ'
          } else if (accionBaja.value === 'darBajaGanaA') {
            props.partido.final = 'GL'
            props.partido.reset = 'GL'
            dataReset.goles_local = props.goles_no_presentacion
            dataReset.goles_visita = 0
          } else if (accionBaja.value === 'darBajaGanaB') {
            props.partido.final = 'GV'
            props.partido.reset = 'GV'
            dataReset.goles_visita = props.goles_no_presentacion
            dataReset.goles_local = 0
          }
          props.partido.penales = null
          accionBaja.value = ''
          setPropsPartido(dataReset)
          emit('recargar', props.partido)
          store.commit('someVariables/UPDATE_SHOW_UPDATE_MATCH', false)
        } else {
          showMessageAlert('danger', 'Ha ocurrido un error vuelve a intentarlo')
        }
        showConfirmacion.value = false
        showLoading.value = false
      }
    }
    function actionAceptar() {
      if (props.partido.final === 'PJ') {
        savePartido()
      } else {
        resetPartido()
      }
    }
    watch(glnp, despues => {
      console.log(despues)
    })

    return {
      value,
      timePicker,
      drawTable,
      // listLocal,
      // listVisita,
      sumarGoles,
      sumarSets,
      totalLocal,
      totalVisita,
      deleteItem,
      updateHoraFechaEtc,
      changeVocal,
      findVocal,
      nameVocal,
      nameVeedor,
      cancha,
      showLoading,
      messageError,
      variante,
      dismissSecs,
      countDownChanged,
      dismissCountDown,
      showMessageAlert,
      verifyPlayer,
      resetModal,
      showConfirmacion,
      continuar,
      savePartido,
      actionAceptar,
      glnp,
      gvnp,
      changeNoPresentacion,
      radioNoPresentacion,
      USER,
      ROLES,
      noSePresentaNinguno,
      noSePresentan,
      closeConfirmacion,
      openVocalia,
      accionBaja,
      DISCIPLINAS,
      actualizarSet,
      time,
      openRespaldos,
      ModalRespaldos,
      //   totalLocalIm,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.name-equipo {
  // background-color: black;
  margin-bottom: 5px;
  font-size: 12px;
  padding: 5px;
  color: black !important;
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
}
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
.ver-vocalia {
  cursor: pointer;
  z-index: 10000;
  /* margin-top: 0px; */
  position: relative;
  top: -15px;
  font-size: 11px;
  color: gray;
  text-decoration-line: underline;
}
</style>
